import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import type { TrustMetric } from '../types';

interface TrustBarProps {
  metrics: TrustMetric[];
}

const TrustBar = ({ metrics }: TrustBarProps) => {
  const [animatedValues, setAnimatedValues] = useState<Record<string, number>>({});

  useEffect(() => {
    const initialValues: Record<string, number> = {};
    metrics.forEach(metric => {
      initialValues[metric.id] = 0;
    });
    setAnimatedValues(initialValues);

    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    metrics.forEach(metric => {
      let currentStep = 0;
      const increment = metric.value / steps;

      const timer = setInterval(() => {
        currentStep++;
        setAnimatedValues(prev => ({
          ...prev,
          [metric.id]: Math.min(Math.round(increment * currentStep), metric.value)
        }));

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, interval);
    });
  }, [metrics]);

  return (
    <div className="bg-card border-y border-border py-8">
      <div className="max-w-content mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {metrics.map((metric) => (
            <div key={metric.id} className="text-center space-y-2">
              <div className="flex items-center justify-center gap-2">
                <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
                <div className="text-3xl sm:text-4xl font-bold text-primary">
                  {animatedValues[metric.id] || 0}
                  {metric.suffix}
                </div>
              </div>
              <div className="text-sm text-secondary font-medium">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;